import { render, staticRenderFns } from "./MailPersistenceEventView.vue?vue&type=template&id=5d4fbe70&scoped=true&"
import script from "./MailPersistenceEventView.vue?vue&type=script&lang=js&"
export * from "./MailPersistenceEventView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4fbe70",
  null
  
)

export default component.exports